import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPallet, ColorPicker, HorizontalScrollList, Input, Label, PortalContainer, Tooltip, useAlert } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { ColorsForMultipleRangesPicker, CustomColorPicker, DefaultColors, IColorForRange, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IDataSource, IDataSourceBinding } from "../../../common/data-source-picker/datasource";
import classNames from "classnames";
import IconEditor from "../../../common/icon-selector/IconEditor";

export interface IProgressBarProperties {
    backgroundColor: string;
    barColorsForRanges: IColorForRange[];
    textColor: string;
    icon: string;
}


export function ProgressBarProperties(props: IProgressBarProperties): IUIPropertyDefinition<IProgressBarProperties> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData) => {

            let _props = props.uiProps

            return (
                <PropertyContainer>
                    <PropertyContainerTitle>Progress Bar</PropertyContainerTitle>
                    <PropertyGroup>

                        <Property>
                            <PropertyTitle>Bar Colors For Ranges</PropertyTitle>
                            <ColorsForMultipleRangesPicker
                                colorsForRanges={_props.barColorsForRanges}
                                onChange={s => {
                                    jp.apply(_props, `$.barColorsForRanges`, () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                        <Property>
                            <PropertyTitle>Text Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.textColor || '#FFFFFF'}
                                onChange={s => {
                                    jp.apply(_props, `$.textColor`, () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Background Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.backgroundColor || '#707070'}
                                onChange={s => {
                                    jp.apply(_props, `$.backgroundColor`, () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>{'Icon'}</PropertyTitle>
                            <IconEditor
                                value={_props.icon || ''}
                                onChange={s => {
                                    jp.apply(_props, `$.icon`, () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                    </PropertyGroup>
                </PropertyContainer>
            )
        }
    };
}
